<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>消除权重配置</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload0"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importProbUploadSuccess(res, 'eliminate')}"
                :headers="headers"
              >
                <el-button :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData('eliminate')"
              >导出</el-button>
            </el-col>
            <el-col :span="1.5"> <clear-cache-apply /> <sync-data /></el-col>
            <el-col :span="1.5"><el-button type="success" size="mini" @click="onSubmit">保存</el-button></el-col>
            <el-col :span="1.5"><el-button type="primary" size="mini" icon="el-icon-plus" @click="add">新增等级</el-button></el-col>
          </el-row>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="lv" label="等级ID" width="100" />
          <el-table-column prop="eliminate_weight.base_coin" label="基础金币" width="120" />
          <el-table-column prop="eliminate_weight.one_coin" label="单行消除金币" width="120" />
          <el-table-column prop="eliminate_weight.two_coin" label="双行消除金币" width="120" />
          <el-table-column prop="eliminate_weight.three_coin" label="三行消除金币" width="120" />
          <el-table-column prop="eliminate_weight.four_coin" label="四行消除金币" width="120" />
          <el-table-column prop="eliminate_weight.five_coin" label="五行消除金币" width="120" />
          <el-table-column prop="eliminate_weight.six_coin" label="六行消除金币" width="120" />
          <el-table-column prop="eliminate_weight.seven_coin" label="七行消除金币" width="120" />
          <el-table-column prop="eliminate_weight.eight_coin" label="八行消除金币" width="120" />
          <el-table-column prop="eliminate_weight.pro" label="连消赔率" width="120" />
          <el-table-column label="操作" width="220">
            <template v-slot:default="scope">
              <div style="display: flex; justify-content: center; gap: 10px;">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="configVisibleArr[scope.$index].visible = true"
                >
                  编辑权重
                </el-button>
                <el-button
                  v-if="unsavedLevels.has(scope.$index)"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="removeLevel(scope.$index)"
                >
                  删除等级
                </el-button>
              </div>
              <el-drawer
                :before-close="(d)=>{return handleClose(d, scope.$index)}"
                :title="`等级 ${scope.row.lv} - 消除权重配置`"
                size="500px"
                :visible="configVisibleArr[scope.$index].visible"
              >
                <el-form :model="scope.row.eliminate_weight" label-width="100px">
                  <el-form-item label="基础金币">
                    <el-input-number v-model="scope.row.eliminate_weight.base_coin" :min="0" size="mini" />
                  </el-form-item>
                  <el-form-item label="单行消除金币">
                    <el-input-number v-model="scope.row.eliminate_weight.one_coin" :min="0" size="mini" />
                  </el-form-item>
                  <el-form-item label="双行消除金币">
                    <el-input-number v-model="scope.row.eliminate_weight.two_coin" :min="0" size="mini" />
                  </el-form-item>
                  <el-form-item label="三行消除金币">
                    <el-input-number v-model="scope.row.eliminate_weight.three_coin" :min="0" size="mini" />
                  </el-form-item>
                  <el-form-item label="四行消除金币">
                    <el-input-number v-model="scope.row.eliminate_weight.four_coin" :min="0" size="mini" />
                  </el-form-item>
                  <el-form-item label="五行消除金币">
                    <el-input-number v-model="scope.row.eliminate_weight.five_coin" :min="0" size="mini" />
                  </el-form-item>
                  <el-form-item label="六行消除金币">
                    <el-input-number v-model="scope.row.eliminate_weight.six_coin" :min="0" size="mini" />
                  </el-form-item>
                  <el-form-item label="七行消除金币">
                    <el-input-number v-model="scope.row.eliminate_weight.seven_coin" :min="0" size="mini" />
                  </el-form-item>
                  <el-form-item label="八行消除金币">
                    <el-input-number v-model="scope.row.eliminate_weight.eight_coin" :min="0" size="mini" />
                  </el-form-item>
                  <el-form-item label="连消倍率">
                    <el-input-number v-model="scope.row.eliminate_weight.pro" :min="0" :max="1000" size="mini" />
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="configVisibleArr[scope.$index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="configClick(scope.$index)">确 定</el-button>
                </div>
              </el-drawer>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
import { exportWeight, getWeightList, importWeight, updateWeight } from '@/api/config/tetris/weight'
export default {
  name: 'TetrisEliminateWeight',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      numbers: [],
      loading: false,
      configVisibleArr: [],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'lv': 0,
          'eliminate_weight': {
            'base_coin': 0,
            'one_coin': 0,
            'two_coin': 0,
            'three_coin': 0,
            'four_coin': 0,
            'five_coin': 0,
            'six_coin': 0,
            'seven_coin': 0,
            'eight_coin': 0,
            'pro': 0
          }
        }
      ],
      unsavedLevels: new Set() // 记录未保存的等级索引
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      updateWeight({ type: 'eliminate', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
          // 保存成功后清空未保存等级记录
          this.unsavedLevels.clear()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    // 删除等级
    removeLevel(index) {
      this.$confirm('确定要删除该等级配置吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.formData.splice(index, 1)
        this.unsavedLevels.delete(index)
        // 更新剩余未保存等级的索引
        const updatedUnsaved = new Set()
        this.unsavedLevels.forEach(idx => {
          if (idx > index) {
            updatedUnsaved.add(idx - 1)
          } else if (idx < index) {
            updatedUnsaved.add(idx)
          }
        })
        this.unsavedLevels = updatedUnsaved
      })
    },
    getTables() {
      this.formData = []
      const params = { ...this.queryParams, type: 'eliminate' }
      getWeightList(params).then(res => {
        this.formData = res.data.list
        this.total = res.data.count
        // 初始化抽屉可见性数组
        this.configVisibleArr = res.data.list.map(() => ({ visible: false }))
        // 从服务端获取的数据都是已保存的，清空未保存等级记录
        this.unsavedLevels.clear()
      })
    },
    add() {
      const lv = this.formData.length
      this.formData.push({
        lv: lv + 1,
        eliminate_weight: {
          'base_coin': 0,
          'one_coin': 0,
          'two_coin': 0,
          'three_coin': 0,
          'four_coin': 0,
          'five_coin': 0,
          'six_coin': 0,
          'seven_coin': 0,
          'eight_coin': 0,
          'pro': 0
        }
      })
      // 更新configVisibleArr数组
      this.configVisibleArr.push({ visible: false })
      // 记录未保存的等级索引
      this.unsavedLevels.add(this.formData.length - 1)
    },
    exportData(template) {
      console.log(template)
      exportWeight({ type: template }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response, template) {
      this.loading = true
      importWeight({ data: response.data.path, type: template }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
          // 清空上传组件的文件列表
          if (this.$refs.upload0) {
            this.$refs.upload0.clearFiles()
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(done, index) {
      this.configVisibleArr[index].visible = false
      done()
    },
    configClick(index) {
      this.configVisibleArr[index].visible = false
      this.onSubmit()
    }

  }
}
</script>

<style scoped>
.box-card {
  padding: 10px;
}

.el-table .el-table__cell {
  padding: 8px 0;
}

.el-table--mini .el-table__cell {
  padding: 4px 0;
}
</style>
